(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cta-action"] && !Shopify.designMode) return;
  try {
    (function () {
    // The snippet renders many times per page; the listener must not.
    if (window.__ctaScrollWired) return;
    window.__ctaScrollWired = true;

    var TARGETS = { 'story-personalise': '[data-story-personalise]' };

    function resolve(name) {
      var selector = TARGETS[name];
      return selector ? document.querySelector(selector) : null;
    }

    // A belt-and-braces pass for a custom product template that drops the story
    // section: Liquid cannot see sibling sections, so only the DOM knows. Hidden
    // rather than removed, so re-adding the section in the editor brings it back.
    function sync() {
      var triggers = document.querySelectorAll('[data-scroll-to]');
      for (var i = 0; i < triggers.length; i++) {
        triggers[i].hidden = !resolve(triggers[i].getAttribute('data-scroll-to'));
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest('[data-scroll-to]') : null;
      if (!trigger) return;
      var target = resolve(trigger.getAttribute('data-scroll-to'));
      if (!target) return;
      event.preventDefault();
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });

    if (document.readyState !== 'loading') sync();
    else document.addEventListener('DOMContentLoaded', sync);
    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('shopify:section:unload', sync);
  })();
  } catch(e) { console.error(e); }
})();

})();
